import { DataObject } from "@lib/titan2/dist/api/core/data/DataObject";
import { Dictionary } from "@lib/titan2/dist/util/collection/Dictionary";
/**
 * Parser.ts
 */
export class Parser {
    constructor() {
        this.responses = new Dictionary();
    }
    addResponse(key, response) {
        if (this.hasResponse(key)) {
            throw new Error(`Attempt to add response to key "${key}" twice.`);
        }
        else {
            if (response && (!Array.isArray(response) || response.length)) {
                this.responses.setValue(key, response);
            }
        }
    }
    hasResponse(key) {
        return this.responses.containsKey(key);
    }
    getResponse(key, data) {
        const response = this.responses.getValue(key);
        const rData = Array.isArray(response) ? response.shift() : response;
        if (Array.isArray(response) && response.length === 0) {
            this.responses.remove(key);
        }
        if (rData instanceof Function) {
            return rData(data);
        }
        else {
            return rData;
        }
    }
    cloneData(data) {
        return new DataObject(JSON.parse(data.getDump()));
    }
}
//# sourceMappingURL=Parser.js.map